module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"company-name":"SVTI","logout":"Ausloggen"},"fr":{"company-name":"ASIT","logout":"Se déconnecter"},"it":{"company-name":"ASIT","logout":"Disconnettersi"}}')
  delete Component.options._Ctor
}
